"use client";

import { Box, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type CountryFlagProps = {
  width?: number;
  height?: number;
  countryCode?: string; // ✅ 전달되면 최우선 사용
};

function countryCodeToEmoji(countryCode: string): string {
  return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

function parseCountryFromAcceptLanguage(lang: string): string | null {
  const match = lang.match(/[a-z]{2}-([A-Z]{2})/);
  return match ? match[1] : null;
}

export default function CountryFlag({ width = 32, height = 26, countryCode }: CountryFlagProps) {
  const [detectedCode, setDetectedCode] = useState<string | null>(countryCode || null);

  useEffect(() => {
    if (countryCode) return; // ✅ props가 있으면 우선 적용

    const cfCountry = (window as any).CF_IPCountry || null;
    if (cfCountry && /^[A-Z]{2}$/.test(cfCountry)) {
      console.log("detectedCode-", cfCountry);
      setDetectedCode(cfCountry);
    } else {
      const lang = navigator.language || navigator.languages?.[0] || "";
      const fallback = parseCountryFromAcceptLanguage(lang);
      if (fallback) {
        setDetectedCode(fallback);
      }
    }
  }, [countryCode]);

  console.log("detectedCode-", detectedCode);
  if (!detectedCode) return null;

  return (
    <Box
      width={width}
      height={height}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      //borderRadius={2} // 사각 라운드 (적당히 둥글게)
      //bgcolor="background.paper"
      sx={{
        overflow: "hidden",
        fontSize: Math.min(width, height) * 1.1,
        lineHeight: 1,
        padding: "1px",
      }}
    >
      <Typography component="span" fontSize="inherit">
        {countryCodeToEmoji(detectedCode)}
      </Typography>
    </Box>
  );
}
